import request from '@/utils/request'
import { Promise } from 'core-js'

export function login(data) {
    //to do
    // const loginUrl = ''
    // return request({
    // 	url: loginUrl,
    // 	method: 'post',
    // 	data
    // })

    let promiseData = {
        data: { token: 'onecode-token' }
    }
    return Promise.resolve(promiseData)
}

export function getInfo(token) {
    //todo
    // const infoUrl = ''
    // return request({
    //     url: infoUrl,
    //     method: 'get',
    //     params: {
    //         token
    //     }
    // })
    return Promise.resolve({
        data: {
            roles: ['admin'],
            name: 'oscar',
            avatar: '',
            introduction: 'i am administrator'
        }
    })
}

export function logout() {
    //todo
    // const logoutUrl = ''
    // return request({
    //     url: logoutUrl,
    //     method: 'post'
    // })
    return Promise.resolve()
}